import {isFeatureEnabled} from '@github-ui/feature-flags'
import {Link} from '@github-ui/react-router'
import {LayoutPrimitivesProvider} from '@github-ui/layout-primitives-core'
import type {PropsWithChildren} from 'react'

export function DotcomLayoutRuntime({children}: PropsWithChildren) {
  const sharedCookieEnabled = isFeatureEnabled('primer_sidebar_shared_cookie')
  const footerOffsetEnabled = isFeatureEnabled('primer_footer_redesign')
  return (
    <LayoutPrimitivesProvider
      linkComponent={Link}
      sharedCookieEnabled={sharedCookieEnabled}
      footerOffsetEnabled={footerOffsetEnabled}
    >
      {children}
    </LayoutPrimitivesProvider>
  )
}
